var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('div',_vm._l((5),function(starIndex){return _c('i',{key:starIndex,class:[_vm.getStarClass(starIndex, _vm.rating), _vm.starClass]})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }